import { Controller } from "@hotwired/stimulus"

// The folded version chips of a document: the title menu's "Version history"
// opens and closes them (document_menu_controller dispatches the event, because
// the menu may live in the side panel's head, outside this element).
export default class extends Controller {
    connect() {
        this._toggle = () => { this.element.hidden = !this.element.hidden }
        window.addEventListener("document:toggle-versions", this._toggle)
    }

    disconnect() {
        window.removeEventListener("document:toggle-versions", this._toggle)
    }
}
